import React, { useEffect, useRef, useState } from "react";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import AdvertCard from "./AdvertCard";
import "./HomeSections.css";

// "Popüler İlanlar" — en çok görüntülenen ilanların yatay kaydırmalı vitrini.
// Al/Sat çift eksenini koruyarak küçük bir filtre sunar (marka renk kodlu).
const TABS = [
  { id: "all", label: "Tümü", color: "#0F1B17" },
  { id: "buyer", label: "Alınan", color: "#F08A3E" },
  { id: "seller", label: "Satılan", color: "#1EC28B" },
];

function PopularAdverts() {
  const [kind, setKind] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const railRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  // Ok butonlarının sönükleşme durumunu kaydırma konumuna göre güncelle.
  const updateArrows = () => {
    const el = railRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 4);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 4);
  };

  const scrollByCards = (dir) => {
    const el = railRef.current;
    if (!el) return;
    // Görünür genişliğin ~%80'i kadar kaydır (yaklaşık 2-3 kart).
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  };

  useEffect(() => {
    const t = setTimeout(updateArrows, 50);
    return () => clearTimeout(t);
  }, [items]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    advertEndpoint
      .getPopularAdverts(8, kind === "all" ? undefined : kind)
      .then((res) => res.data)
      .then((data) => {
        if (!active) return;
        setItems(data?.results || []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setItems([]);
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [kind]);

  const accent = TABS.find((t) => t.id === kind)?.color || "#0F1B17";

  return (
    <div className="hs-section container">
      <div className="hs-head">
        <div className="hs-head__titles">
          <span className="hs-head__bar" style={{ background: accent }} />
          <div className="hs-head__text">
            <h2>Popüler İlanlar</h2>
            <p>En çok ilgi gören ilanlar</p>
          </div>
        </div>
        <div className="d-flex" style={{ gap: 8, flexWrap: "wrap" }}>
          {TABS.map((tab) => {
            const active = kind === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setKind(tab.id)}
                style={{
                  padding: "6px 16px",
                  borderRadius: 999,
                  border: `1.5px solid ${tab.color}`,
                  background: active ? tab.color : "transparent",
                  color: active ? "#fff" : tab.color,
                  fontWeight: 700,
                  fontSize: 13,
                  cursor: "pointer",
                  outline: "none",
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {loading ? (
        <div style={{ padding: "40px 0", textAlign: "center", color: "#7a8a85" }}>
          Yükleniyor...
        </div>
      ) : items.length === 0 ? (
        <div style={{ padding: "30px 0", textAlign: "center", color: "#7a8a85" }}>
          Bu kategoride henüz ilan yok.
        </div>
      ) : (
        <div className="hs-rail-wrap">
          <button
            type="button"
            className="hs-arrow hs-arrow--left"
            onClick={() => scrollByCards(-1)}
            disabled={atStart}
            aria-label="Geri"
          >
            <i className="fa fa-angle-left" />
          </button>
          <div className="hs-rail" ref={railRef} onScroll={updateArrows}>
            {items.map((item) => (
              <AdvertCard advert={item} key={item.id || item._id} />
            ))}
          </div>
          <button
            type="button"
            className="hs-arrow hs-arrow--right"
            onClick={() => scrollByCards(1)}
            disabled={atEnd}
            aria-label="İleri"
          >
            <i className="fa fa-angle-right" />
          </button>
        </div>
      )}
    </div>
  );
}

export default PopularAdverts;
